import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import { BusinessInquirySection } from "@/components/BusinessInquirySection";

const CAFE = "/assets/bergen-local-atmosphere.png";
const brands = ["La Marzocco", "Rocket", "Rancilio", "Nuova Simonelli", "Franke", "WMF", "Eversys", "La Cimbali M100"];

export default function ProfesjonelleKaffemaskiner() {
  return (
    <Layout>
      <section className="relative overflow-hidden">
        <div className="absolute inset-0"><img src={CAFE} alt="Profesjonelle kaffemaskiner" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-gradient-to-r from-[#3D2314]/90 to-[#3D2314]/60" /></div>
        <div className="relative max-w-7xl mx-auto px-4 py-24 md:py-32">
          <div className="max-w-2xl">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 font-display">Service på profesjonelle kaffemaskiner i Bergen</h1>
            <p className="text-lg text-white/90 mb-6">Service og reparasjon av espressomaskiner for kafeer, restauranter og storkjøkken i Bergen.</p>
            <Button asChild size="lg" className="bg-[#D4A574] hover:bg-[#D4A574]/90 text-[#3D2314] font-semibold"><Link to="/kontakt-skjema">Kontakt oss</Link></Button>
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-[#FFF8F0]">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-[#3D2314] mb-4 text-center font-display">Merker vi jobber med</h2>
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {brands.map((b) => <span key={b} className="bg-white px-4 py-2 rounded-full text-sm font-medium text-[#3D2314] border border-[#3D2314]/20">{b}</span>)}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {["Avkalking og full rengjøring av bryggegruppe", "Bytte av pakninger, dusjsiler og o-ringer", "Trykk- og temperaturkalibrering", "Reparasjon av pumper, ventiler og elektronikk", "Forebyggende vedlikehold på serviceavtale", "Rask utrykning for bedrifter i drift"].map((i) => (
              <div key={i} className="flex items-start gap-2 bg-white rounded-lg p-4 border border-[#D4A574]/20"><CheckCircle className="h-4 w-4 text-green-600 mt-0.5 shrink-0" /><span className="text-sm text-[#1A1A1A]/80">{i}</span></div>
            ))}
          </div>
        </div>
      </section>
      <BusinessInquirySection
        source="profesjonell"
        title="Rask forespørsel for espressomaskin i drift"
        intro="Har kafeen, restauranten eller bensinstasjonen en profesjonell kaffe- eller espressomaskin som lekker, mister trykk eller viser feilkode? Beskriv maskinen og problemet, så tar vi kontakt for å avtale diagnostikk i Bergen eller omegn."
      />
      <section className="py-12 bg-[#3D2314]">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-white mb-4 font-display">Trenger dere rask hjelp?</h2>
          <p className="text-white/70 mb-6">Vi vet at nedetid koster. Kontakt oss for prioritert service.</p>
          <Button asChild size="lg" className="bg-[#D4A574] hover:bg-[#D4A574]/90 text-[#3D2314] font-semibold"><Link to="/bedrift">Se bedriftsavtaler</Link></Button>
        </div>
      </section>
    </Layout>
  );
}
